import { Button } from "@/components/ui/button";
import { createFileRoute } from "@tanstack/react-router";
import { Github } from "lucide-react";

export const Route = createFileRoute("/(auth)/auth/")({
  component: AppOverview,
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
});

function AppOverview() {
  const search = Route.useSearch();
  const redirectParam = search.redirect;
  const authorizeUrl = redirectParam
    ? `/api/auth/authorize?redirect=${encodeURIComponent(redirectParam)}`
    : "/api/auth/authorize";

  return (
    <div className="flex flex-col items-center space-y-6">
      <div className="text-center p-4 backdrop-blur-sm bg-white/5 dark:bg-black/5 border border-white/10 dark:border-white/10 rounded-md mb-2">
        <p className="text-white/90 dark:text-white/90">
          Currently we are invite only.
        </p>
        <p className="text-white/90 dark:text-white/90">
          If you have received an invite use the login button below or reach out
          to{" "}
          <a
            href="https://x.com/mies"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white font-semibold underline hover:text-white/80"
          >
            Mies
          </a>{" "}
          to get an invite.
        </p>
      </div>
      <a href={authorizeUrl} className="w-full">
        <Button
          className="w-full backdrop-blur-sm bg-white/10 hover:bg-white/20 dark:bg-black/10 dark:hover:bg-black/20 border-white/20 dark:border-white/10 text-white"
          size="lg"
        >
          <Github className="mr-2" />
          Continue with GitHub
        </Button>
      </a>
      <p className="text-xs text-white/70 dark:text-white/70 text-center">
        {/* TODO: Add links to the terms of service and privacy policy */}
        By continuing, you agree to our
        <br />
        <a
          href="https://docs.fiberplane.com/privacy-policy/"
          className="underline"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
}
